module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "onboard-arrow",
    class: {
      'is-in-setup-widget': _vm.setupWidget
    }
  }, [_c('div', {
    staticClass: "arrow_box no-print animated infinite onboarding_animate"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-141ad5e2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/onboarding/OnboardArrow.vue
// module id = 1772
// module chunks = 1